import styled from 'styled-components';
import { Colors } from '../../../types';
import { devices } from '../../../styles/viewports';

type withColor = {
  theme: {
    color: Colors;
  };
};

export const Wrapper = styled.div`
  background-color: var(--base-color-lightgrey);
  padding: 40px;

  display: block;
  position: relative;

  @media ${devices.tablet} {
    margin-top: 0;
    padding: 40px 20px;
  }
`;

export const PromoLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-self: flex-end;
  height: 15px;
`;

export const PromoLabel = styled.div<withColor>`
  background: ${({ theme }) => theme.colors.primary};
  color: ${Colors.White};
  padding: 6px 8px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 0;
  width: auto;
  margin: auto;
  font-family: var(--font-family-header);
  font-feature-settings: 'tnum' on, 'lnum' on, 'liga' off, 'calt' off;
  font-size: var(--font-size-overline-2);
  line-height: 12px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const ButtonContainer = styled.div`
  margin-top: 2em;
  width: fit-content;
`;

export const TitleContainer = styled.div`
  & > * {
    margin-top: 0;
    margin-bottom: 0.5em;
  }
`;

export const OfferTextWrapper = styled.div`
  & > * {
    margin-bottom: 0.5em;
  }
  margin-bottom: 1em;
`;

export const PriceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  padding: 5px 0 8px 0;
`;

export const LineThrough = styled.div`
  text-decoration-line: line-through;
  color: var(--base-color-darkgrey);
`;
